export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  status: "连载" | "完结";
  cover: string;
  intro: string;
  tags: string[];
  latestChapter: number;
  updatedAt: string;
  rating: number;
}

export interface ComicCategory {
  key: string;
  name: string;
  icon: string;
  desc: string;
}

export const comicCategories: ComicCategory[] = [
  { key: "elf", name: "精灵", icon: "ri-leaf-line", desc: "优雅灵动的森林精灵与月光精灵故事" },
  { key: "yokai", name: "妖怪", icon: "ri-ghost-smile-line", desc: "百鬼夜行与民间妖怪的奇谈怪话" },
  { key: "magic", name: "魔法生物", icon: "ri-magic-line", desc: "幻兽、龙族与魔法造物的冒险物语" },
  { key: "flower", name: "花之精", icon: "ri-plant-line", desc: "花田精灵与季节轮转的温柔小故事" },
  { key: "forest", name: "森林守护", icon: "ri-sun-line", desc: "守护远古森林与巨树的守望者传说" },
  { key: "royal", name: "妖精王族", icon: "ri-vip-crown-line", desc: "妖精王庭与王族血脉的宏大史诗" },
];

export const comics: Comic[] = [
  {
    id: "c01",
    title: "妖精的森林物语",
    author: "森野绘",
    category: "精灵",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Mystical%20fairy%20forest%20comic%20cover%20art%20with%20a%20young%20elf%20girl%20surrounded%20by%20glowing%20fireflies%20and%20lush%20green%20foliage%2C%20soft%20violet%20and%20emerald%20color%20palette%2C%20dreamy%20fantasy%20illustration%2C%20detailed%20painterly%20style%2C%20warm%20atmospheric%20lighting&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    intro: "失去故乡的森林精灵少女莉芙，闯入一片会呼吸的古老树林。她必须唤醒沉睡的树灵，才能让自己的世界重新长出春天。",
    tags: ["奇幻", "治愈", "森林", "成长"],
    latestChapter: 87,
    updatedAt: "2026-10-12",
    rating: 9.4,
  },
  {
    id: "c02",
    title: "月光精灵的契约",
    author: "白露",
    category: "精灵",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Moonlight%20fairy%20comic%20cover%20featuring%20a%20silver%20haired%20spirit%20woman%20standing%20on%20a%20moonlit%20lake%20with%20floating%20rune%20circles%20and%20soft%20glow%2C%20indigo%20and%20pale%20gold%20tones%2C%20elegant%20fantasy%20art%20style%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    intro: "每逢满月，湖畔便会出现一位只会说谎的月光精灵。与她签下契约的人类少年，要用真心换回一个早已遗忘的约定。",
    tags: ["契约", "治愈", "月光", "恋爱"],
    latestChapter: 64,
    updatedAt: "2026-10-11",
    rating: 9.1,
  },
  {
    id: "c03",
    title: "妖怪茶馆夜话",
    author: "狐月",
    category: "妖怪",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Yokai%20tea%20house%20comic%20cover%20with%20a%20fox%20spirit%20serving%20tea%20in%20a%20dim%20lantern%20lit%20wooden%20tea%20room%2C%20floating%20paper%20lanterns%20and%20eerie%20warm%20orange%20glow%2C%20Japanese%20folklore%20illustration%20style%2C%20intricate%20details%2C%20moody%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    intro: "深巷尽头有一家只在子时开门的小茶馆。掌柜是位爱讲故事的狐妖，而每位深夜到访的客人，都带着一段未了的愿望。",
    tags: ["妖怪", "单元剧", "温情", "和风"],
    latestChapter: 112,
    updatedAt: "2026-10-12",
    rating: 9.5,
  },
  {
    id: "c04",
    title: "幻蝶魔法生物图鉴",
    author: "青木翔",
    category: "魔法生物",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20comic%20cover%20of%20giant%20glowing%20butterfly%20magical%20creatures%20with%20iridescent%20wings%20flying%20above%20a%20herbalist%20girl%2C%20teal%20and%20amber%20color%20scheme%2C%20whimsical%20detailed%20illustration%2C%20soft%20bokeh%20background%2C%20enchanting%20mood&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    intro: "年轻的博物学者带着一本会自己翻页的图鉴，走遍魔法大陆，只为记录下每一种濒临消失的幻蝶与魔法生物。",
    tags: ["冒险", "图鉴", "幻想", "生物"],
    latestChapter: 45,
    updatedAt: "2026-10-09",
    rating: 8.8,
  },
  {
    id: "c05",
    title: "蒲公英精灵的旅行",
    author: "花小满",
    category: "花之精",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20comic%20cover%20of%20a%20tiny%20dandelion%20flower%20spirit%20girl%20riding%20a%20floating%20seed%20across%20a%20sunny%20meadow%2C%20pastel%20yellow%20and%20mint%20green%20palette%2C%20watercolor%20fantasy%20illustration%2C%20soft%20daylight%2C%20heartwarming%20tone&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    intro: "春天结束的那天，蒲公英精灵离开了花田。她乘着风，替每一颗种子寻找一个愿意生根的地方。",
    tags: ["治愈", "旅行", "完结", "清新"],
    latestChapter: 40,
    updatedAt: "2026-08-20",
    rating: 9.2,
  },
  {
    id: "c06",
    title: "千年树灵守望者",
    author: "岩谷澈",
    category: "森林守护",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20comic%20cover%20of%20a%20towering%20ancient%20tree%20spirit%20guardian%20with%20glowing%20moss%20veins%20standing%20in%20a%20misty%20primordial%20forest%2C%20deep%20green%20and%20muted%20gold%20tones%2C%20dramatic%20lighting%2C%20highly%20detailed%20concept%20art&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    intro: "当第一棵巨树开始枯萎，沉睡了千年的守望者睁开眼睛。他要用最后的力气，抵挡住正翻越山脉而来的荒芜。",
    tags: ["史诗", "守护", "奇幻", "热血"],
    latestChapter: 73,
    updatedAt: "2026-10-10",
    rating: 9.0,
  },
  {
    id: "c07",
    title: "妖精女王与银钥匙",
    author: "维多利亚",
    category: "妖精王族",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Royal%20fairy%20comic%20cover%20of%20a%20regal%20fairy%20queen%20holding%20an%20ornate%20silver%20key%20in%20a%20candlelit%20throne%20hall%20with%20stained%20glass%2C%20purple%20and%20gold%20royal%20palette%2C%20elegant%20detailed%20fantasy%20illustration%2C%20majestic%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    intro: "妖精王座空悬百年，唯一的继承人却把开启王庭的银钥匙弄丢了。她必须在下一次加冕日之前，找回属于自己的命运。",
    tags: ["王族", "宫廷", "奇幻", "悬疑"],
    latestChapter: 58,
    updatedAt: "2026-10-08",
    rating: 8.9,
  },
  {
    id: "c08",
    title: "风之妖精的恋歌",
    author: "铃兰",
    category: "精灵",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20comic%20cover%20of%20a%20wind%20fairy%20girl%20with%20flowing%20hair%20singing%20atop%20a%20cliff%20over%20a%20sea%20of%20clouds%2C%20sky%20blue%20and%20rose%20gold%20palette%2C%20delicate%20painterly%20illustration%2C%20breezy%20romantic%20mood%2C%20soft%20light&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    intro: "风之妖精无法在同一个地方停留太久。可她偏偏爱上了一位走不出山谷的牧羊少年，爱情与自由，她只能选一个。",
    tags: ["恋爱", "完结", "催泪", "自由"],
    latestChapter: 52,
    updatedAt: "2026-07-15",
    rating: 9.3,
  },
  {
    id: "c09",
    title: "百鬼夜行绘卷",
    author: "天野妖",
    category: "妖怪",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Dark%20folklore%20comic%20cover%20of%20a%20night%20parade%20of%20Japanese%20yokai%20monsters%20with%20masks%20and%20lanterns%20moving%20through%20a%20village%20street%2C%20crimson%20and%20ink%20black%20palette%2C%20traditional%20ukiyo%20e%20inspired%20illustration%2C%20ominous%20atmospheric%20detail&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    intro: "一位能看见妖怪的落第画师，被卷入百年一度的百鬼夜行。他要画完这幅绘卷，才能让小镇躲过一夜的灾祸。",
    tags: ["妖怪", "和风", "悬疑", "热血"],
    latestChapter: 95,
    updatedAt: "2026-10-12",
    rating: 9.1,
  },
  {
    id: "c10",
    title: "龙鳞魔法学院",
    author: "星野凛",
    category: "魔法生物",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Magic%20academy%20comic%20cover%20showing%20students%20with%20a%20small%20friendly%20dragon%20in%20a%20grand%20stone%20castle%20library%20full%20of%20floating%20books%2C%20sapphire%20and%20copper%20tones%2C%20vibrant%20shonen%20fantasy%20illustration%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    intro: "在只有贵族才能入学的高塔学院里，一个捡到龙鳞的平民少年，成了传说中早已灭绝的驭龙者血脉最后的希望。",
    tags: ["学院", "热血", "龙族", "成长"],
    latestChapter: 130,
    updatedAt: "2026-10-11",
    rating: 9.0,
  },
  {
    id: "c11",
    title: "铃兰精灵的告白",
    author: "花小满",
    category: "花之精",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20comic%20cover%20of%20a%20lily%20of%20the%20valley%20flower%20spirit%20girl%20blushing%20while%20holding%20a%20tiny%20bouquet%2C%20pale%20green%20and%20cream%20palette%2C%20gentle%20shoujo%20illustration%20style%2C%20delicate%20flowers%20and%20soft%20bokeh%2C%20sweet%20mood&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    intro: "花田里最小的铃兰精灵，暗恋着每天来浇水的园丁学徒。可花精一旦说出口，就会化作清晨的第一滴露水。",
    tags: ["恋爱", "治愈", "花精", "催泪"],
    latestChapter: 36,
    updatedAt: "2026-10-07",
    rating: 8.7,
  },
  {
    id: "c12",
    title: "苔藓精灵的低语",
    author: "森野绘",
    category: "森林守护",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Enchanting%20comic%20cover%20of%20a%20tiny%20moss%20spirit%20creature%20with%20glowing%20eyes%20resting%20on%20a%20wet%20stone%20in%20a%20rainy%20forest%2C%20muted%20emerald%20and%20grey%20palette%2C%20cozy%20detailed%20fantasy%20illustration%2C%20misty%20soft%20lighting&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    intro: "被人类遗忘的古老咒语，都藏在苔藓的褶皱里。只有这个不爱说话的苔藓精灵，还记得整片森林曾经的名字。",
    tags: ["治愈", "森林", "安静", "奇幻"],
    latestChapter: 28,
    updatedAt: "2026-10-06",
    rating: 8.6,
  },
  {
    id: "c13",
    title: "露珠与月桂冠",
    author: "白露",
    category: "妖精王族",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20fantasy%20comic%20cover%20of%20a%20fairy%20princess%20wearing%20a%20laurel%20wreath%20crowned%20with%20glittering%20dewdrops%20in%20a%20moonlit%20garden%2C%20silver%20lavender%20and%20pearl%20palette%2C%20ornate%20detailed%20illustration%2C%20serene%20regal%20mood&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    intro: "王庭的小公主被诅咒永远无法流泪。直到那一滴迟到了十六年的露珠，落在她亲手为挚友戴上的月桂冠上。",
    tags: ["王族", "完结", "催泪", "治愈"],
    latestChapter: 48,
    updatedAt: "2026-06-30",
    rating: 9.1,
  },
  {
    id: "c14",
    title: "冰晶精灵的苏醒",
    author: "雪见遥",
    category: "精灵",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Frozen%20fantasy%20comic%20cover%20of%20an%20ice%20crystal%20fairy%20girl%20waking%20inside%20a%20giant%20translucent%20frozen%20flower%2C%20glacier%20blue%20and%20white%20palette%20with%20violet%20highlights%2C%20crystal%20sharp%20detailed%20illustration%2C%20cold%20shimmering%20light&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    intro: "南国出生的小透明魔法师，误打误撞解开了千年冰晶的封印。从里面苏醒的精灵，却把他当成了命中注定的宿敌。",
    tags: ["奇幻", "搞笑", "冰系", "冒险"],
    latestChapter: 41,
    updatedAt: "2026-10-05",
    rating: 8.5,
  },
  {
    id: "c15",
    title: "猫又居酒屋奇谭",
    author: "狐月",
    category: "妖怪",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20yokai%20comic%20cover%20of%20a%20two%20tailed%20cat%20spirit%20grilling%20skewers%20in%20a%20small%20izakaya%20at%20night%2C%20warm%20amber%20lanterns%20and%20dark%20wood%20tones%2C%20charming%20detailed%20Japanese%20folklore%20illustration%2C%20inviting%20night%20mood&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    intro: "一条偏僻小巷里的居酒屋，掌勺的是位两尾猫又。深夜光顾的客人，有失意的上班族，也有迷路的山神。",
    tags: ["妖怪", "美食", "单元剧", "温情"],
    latestChapter: 67,
    updatedAt: "2026-10-09",
    rating: 8.9,
  },
  {
    id: "c16",
    title: "独角兽与星尘绘师",
    author: "青木翔",
    category: "魔法生物",
    status: "完结",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20comic%20cover%20of%20a%20young%20painter%20riding%20a%20luminous%20unicorn%20across%20a%20starlit%20sky%20trailing%20glittering%20stardust%2C%20deep%20navy%20and%20silver%20palette%20with%20gold%20sparkles%2C%20dreamy%20detailed%20illustration%2C%20magical%20night%20scene&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    intro: "能用星尘作画的少年，被独角兽选中成为它的骑手。他们要在星辰熄灭之前，画出照亮整个夜空的那一幅画。",
    tags: ["冒险", "完结", "幻想", "治愈"],
    latestChapter: 60,
    updatedAt: "2026-05-18",
    rating: 9.2,
  },
  {
    id: "c17",
    title: "向日葵精灵的夏日",
    author: "花小满",
    category: "花之精",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Sunny%20comic%20cover%20of%20a%20cheerful%20sunflower%20spirit%20girl%20running%20through%20a%20golden%20field%20under%20blue%20summer%20sky%2C%20vibrant%20yellow%20and%20warm%20green%20palette%2C%20bright%20joyful%20illustration%2C%20energetic%20lively%20mood&width=600&height=800&seq=comic-cover-17&orientation=portrait",
    intro: "向日葵精灵只在夏天苏醒，每到秋天就会把记忆忘光。所以这个夏天，她决定把和男孩的每一天都画进日记里。",
    tags: ["治愈", "夏日", "青春", "清新"],
    latestChapter: 33,
    updatedAt: "2026-10-04",
    rating: 8.8,
  },
  {
    id: "c18",
    title: "远古巨树之根",
    author: "岩谷澈",
    category: "森林守护",
    status: "连载",
    cover: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20comic%20cover%20of%20colossal%20ancient%20tree%20roots%20winding%20underground%2C%20a%20young%20guardian%20with%20a%20staff%20descending%20into%20a%20glowing%20cavern%2C%20dark%20green%20and%20amber%20palette%2C%20dramatic%20detailed%20concept%20illustration&width=600&height=800&seq=comic-cover-18&orientation=portrait",
    intro: "地表之下盘踞着比山脉更古老的根须。当新一代守望者决定潜入地底，他才发现森林的敌人，从来都不在天空之上。",
    tags: ["史诗", "冒险", "守护", "悬疑"],
    latestChapter: 79,
    updatedAt: "2026-10-08",
    rating: 8.7,
  },
];